@if (HasRequiredPermissions) {
  @if (EntityInstance || isNew()) {
    <!-- Conteneur principal avec layout flexbox -->
    <div class="flex flex-col h-full">
      <!-- Titre fixe en dehors de la zone de défilement -->
      <div class="px-6 pt-4 pb-2">
        <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
          @if (isNew()) {
            {{ 'entities.role.newEntity' | translate }}
          } @else {
            {{ 'entities.role.detailEntity' | translate }}
          }
        </h4>
        <div class="flex justify-between items-center">
          <button (click)="cancelEdit()" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <!-- Zone de contenu avec défilement -->
      <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
        <!--  Conteneur desactivable -->
        <div class="{{this.UpdateMode}}">
          <!-- Informations du rôle -->
          <div class="mt-4">
            <h3 class="{{Skin.formSectionSmallTitle}}">
              <i class="fa-solid fa-user"></i> {{
              'vues.role.detail.sections.role-info' | translate
              }}
            </h3>
            <div class="space-y-2">
              <div>
                <label class="{{Skin.upperCaseSmallLabel}}">{{ 'entities.role.propreties.title' | translate }}</label>
                @if (!isEditMode()) {
                  <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
                    {{ EntityInstance?.title }}
                  </div>
                } @else {
                  <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'title')"
                    class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('title')">
                    @if (hasValidationErrors('title')) {
                      <div class="text-red-600 text-xs mt-1">
                        @for (error of getValidationErrors('title'); track error) {
                          <div>{{ error | translate }}</div>
                        }
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
            <!-- Permissions du rôle -->
            <div class="mt-10 mb-16">
              <h3 class="{{Skin.formSectionSmallTitle}}">
                <i class="fa-solid fa-user"></i> {{
                'vues.role.detail.sections.role-permissions' | translate
                }}
              </h3>
              <div class="space-y-2">
                <div>
                  <app-tree-view [treeData]="permissionsData" (selectedDataChange)="onChange($event)">
                  </app-tree-view>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bandeau pour le nombre d'erreurs -->
        @if (generalErrorCount() > 0) {
          <div class="p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs text-center mb-2">
            <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
            {{ generalErrorCount() }} erreur(s) dans le formulaire
          </div>
        }
        <!-- Boutons en bas du formulaire - TOUJOURS VISIBLES -->
        <div class="bg-stone-50 w-full flex space-x-1 justify-center pt-2 border-t border-gray-200 pb-2">
          <button type="button" (click)="saveItem()" [disabled]="!isFormValid()"
            class="{{Skin.btnPrimary}} uppercase py-2 px-2">
            <i class="far fa-check-square mr-2"></i>
            {{ 'buttons.save' | translate }}
          </button>
          <button type="button" (click)="saveAndCloseItem()" [disabled]="!isFormValid()"
            class="{{Skin.btnPrimary}} uppercase py-2 px-2">
            <i class="far fa-check-square mr-2"></i>
            {{ 'buttons.save-and-close' | translate }}
          </button>
          <button (click)="cancelEdit()" class="{{Skin.btnAlert}} uppercase py-2 px-2">
            <i class="fas fa-times mr-2"></i>
            {{ 'buttons.cancel' | translate }}
          </button>
        </div>
      </div>
    }
  }